export default "__VITE_ASSET__CoCI0S0K__"